import $ from 'jquery';

$(document).on('click', '.videos__item--playlist.js', function() {
    var $this = $(this);
    var videoLink = $this.data('video-link');
    var videosiFrame = $this.parents('.videos').find('.videos__frame iframe');
    var iframeEmbed = 'https://www.youtube.com/embed/' + videoLink + '?autoplay=1&controls=1&playlist=' + videoLink + '&rel=0&modestbranding=1&showinfo=0&autohide=1?enablejsapi=1';

    var videoTitle = $(this).find('.title').html();
    var videoChannel = $(this).find('.channel').html();
    
    $this.parents('.videos__list').find('.videos__item').not($this).removeClass('active');
    $this.addClass('active');

    $('.videos__frame iframe').not(videosiFrame).removeClass('iframe-active');

    videosiFrame.addClass('iframe-active').attr('data-video', videoLink);

    $('.videos__stage').find('.title').html(videoTitle);
    $('.videos__stage').find('.channel').html(videoChannel);

    $this.parents('.videos').find('.videos__frame iframe').attr('src', iframeEmbed);

    $('.videos__frame iframe:not(.iframe-active)').each(function(){
        
        var thisVideoCurrent = $(this).attr('data-video');
        var iframeEmbed_current = 'https://www.youtube.com/embed/' + thisVideoCurrent + '?autoplay=0&controls=1&playlist=' + thisVideoCurrent + '&rel=0&modestbranding=1&showinfo=0&autohide=1?enablejsapi=1';

        $(this).attr('src', iframeEmbed_current);
    });
});

// $(document).on('click', '.videos__frame', function() { 

//     $('.videos__frame iframe').not($(this)).each(function(){
//         var video_link_not = $(this).data('video');
//         var video_embed = 'https://www.youtube.com/embed/' + video_link_not + '?autoplay=0&controls=1&playlist=' + video_link_not + '&rel=0&modestbranding=1&showinfo=0&autohide=1?enablejsapi=1';
//         $(this).attr('src', video_embed);
//     });
// });
